// based on 2.0.0
import TouchFeedback from './src/TouchFeedback';
export default TouchFeedback;


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-m-feedback/index.js
// module id = 816
// module chunks = 0